import React from 'react';
import './styles.css';

const TableLoader: React.FC = () => (
  <div className="table-loader-overlay">
    <div className="table-loader-content">
      <div className="table-loader-spinner" />
      <span className="table-loader-text">Loading...</span>
    </div>
  </div>
);

export default TableLoader;
